import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const SC_Footer = styled.footer.attrs(props => ({
	className: "bg-dark",
}))`
	padding-top: ${props => props.theme.spacer};
	padding-bottom: ${props => props.theme.spacer};
	font-size: ${props => props.theme.fontSizeSm};
	color: ${props => props.theme.gray500};
`

export const SC_FooterText = styled.p.attrs(props => ({

}))`

`

export const SC_FooterLink = styled(Link).attrs(props => ({
  className: "text-muted btn btn-link",
}))`
  
`


